import { useQueryClient } from '@tanstack/react-query';
import {
  GET_ALL_PATIENTS_KEY,
  GET_ACTIVE_PATIENTS_KEY,
  GET_ALL_ARCHIVED_PATIENTS_KEY,
} from '_api/queries/patient';

import useApiMutation from '../useApiMutation';

export const DELETE_PATIENT_KEY = 'delete-patient';

export const useDeletePatient = () => {
  const queryClient = useQueryClient();
  return useApiMutation<{}, { patientId: number }>(
    ({ patientId }) => `/patient/${patientId}`,
    'delete',
    {},
    {
      mutationKey: [DELETE_PATIENT_KEY],
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [GET_ACTIVE_PATIENTS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_PATIENTS_KEY] });
        queryClient.invalidateQueries({ queryKey: [GET_ALL_ARCHIVED_PATIENTS_KEY] });
      },
    },
  );
};
